import { render, staticRenderFns } from "./putOnRecord.vue?vue&type=template&id=588faacb"
import script from "./putOnRecord.vue?vue&type=script&lang=js"
export * from "./putOnRecord.vue?vue&type=script&lang=js"
import style0 from "./putOnRecord.vue?vue&type=style&index=0&id=588faacb&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports